import { css } from "@emotion/css";
import { ActionButton, ActionButtonType, resetStyles } from "@octopusdeploy/design-system-components";
import { fontWeight, space, text, themeTokens } from "@octopusdeploy/design-system-tokens";
import type { SystemInfoResource } from "@octopusdeploy/octopus-server-client";
import type { FC } from "react";
import { default as DurationLabel } from "~/components/TimeLabels/DurationLabel";
import ByteSizeFormatter from "~/utils/ByteSizeFormatter";
interface SystemInformationProps {
    systemInfo: SystemInfoResource;
    onCollectClicked(): void;
}
const SystemInformation: FC<SystemInformationProps> = (props) => {
    const si = props.systemInfo;
    return (<section>
            <h4>System Information</h4>
            <dl className={styles.container}>
                <dt className={styles.label}>OS Version</dt>
                <dd className={styles.value}>{si.OSVersion}</dd>

                <dt className={styles.label}>CLR Version</dt>
                <dd className={styles.value}>{si.ClrVersion}</dd>

                <dt className={styles.label}>Working Set</dt>
                <dd className={styles.workingSetContainer}>
                    <span className={styles.value}>{ByteSizeFormatter(si.WorkingSetBytes)}</span>
                    <ActionButton label="Collect" onClick={() => props.onCollectClicked()} type={ActionButtonType.Ternary}/>
                </dd>

                <dt className={styles.label}>Threads</dt>
                <dd className={styles.value}>{si.ThreadCount}</dd>

                <dt className={styles.label}>Uptime</dt>
                <dd className={styles.value}>
                    <DurationLabel duration={si.Uptime}/>
                </dd>
            </dl>
        </section>);
};
SystemInformation.displayName = "SystemInformation";
const styles = {
    container: css({
        ...resetStyles.description,
        display: "flex",
        flexDirection: "column",
        gap: space[8],
    }),
    label: css({
        ...resetStyles.description,
        font: text.body.regular.small,
        fontWeight: fontWeight["600"],
        color: themeTokens.color.text.secondary,
    }),
    value: css({
        ...resetStyles.description,
        font: text.body.regular.small,
        color: themeTokens.color.text.primary,
    }),
    workingSetContainer: css({
        ...resetStyles.description,
        display: "flex",
        flexDirection: "column",
        gap: space[8],
    }),
};
export default SystemInformation;
